import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-0.5,-2.5h1v1h-1zM-1,-1.5h1.5v1.5h-1.5zM-4,0h0.5v0.5h-0.5zM-0.5,0h1v0.5h-1zM3.5,0h0.5v0.5h-0.5zM-3,0.5h2.5v0.5h-2.5zM0.5,0.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'trunk',
      d: 'M0,-7h0.5v0.5h-0.5zM-1.5,-6.5h3v0.5h-3zM-2,-6h3v0.5h-3zM1.5,-6h0.5v1.5h-0.5zM-2,-5.5h1.5v0.5h-1.5zM0.5,-5.5h0.5v3.5h-0.5zM-2,-5h1v2.5h-1zM-2.5,-2.5h1.5v0.5h-1.5zM-2.5,-2h2v0.5h-2zM0.5,-2h1v1h-1zM2,-2h0.5v1h-0.5zM-2.5,-1.5h1.5v0.5h-1.5zM-3,-1h2v1h-2zM0.5,-1h2v0.5h-2zM0.5,-0.5h2.5v0.5h-2.5zM-3.5,0h2.5v0.5h-2.5zM0.5,0h3v0.5h-3zM0,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'bareBranch',
      d: 'M-0.5,-7h0.5v0.5h-0.5zM1,-6h0.5v1.5h-0.5zM-0.5,-5.5h1v0.5h-1zM-1,-5h1.5v2.5h-1.5zM1,-4.5h1v2.5h-1zM-1,-2.5h0.5v0.5h-0.5zM1.5,-2h0.5v1h-0.5zM-1,0h0.5v0.5h-0.5zM-0.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M0,-15h0.5v0.5h-0.5zM-1,-14.5h0.5v0.5h-0.5zM-1.5,-14h0.5v0.5h-0.5zM0.5,-14h1.5v0.5h-1.5zM-2.5,-13.5h1v0.5h-1zM1.5,-13.5h1v0.5h-1zM-3,-13h1v1.5h-1zM2,-13h1v1h-1zM1.5,-12h1.5v0.5h-1.5zM-3.5,-11.5h1v0.5h-1zM2,-11.5h1.5v0.5h-1.5zM-4,-11h1v0.5h-1zM2.5,-11h1.5v0.5h-1.5zM-4.5,-10.5h1v1.5h-1zM3,-10.5h1v0.5h-1zM2.5,-10h1.5v0.5h-1.5zM3,-9.5h1.5v0.5h-1.5zM-5,-9h0.5v0.5h-0.5zM3.5,-9h1.5v1h-1.5zM-5.5,-8.5h0.5v0.5h-0.5zM-6,-8h0.5v0.5h-0.5zM0,-8h2v0.5h-2zM3.5,-8h2v0.5h-2zM-6,-7.5h2.5v0.5h-2.5zM-1,-7.5h6.5v0.5h-6.5zM-6,-7h5.5v0.5h-5.5zM0.5,-7h4.5v0.5h-4.5zM-5,-6.5h3.5v0.5h-3.5zM1.5,-6.5h3v0.5h-3zM-4,-6h2v0.5h-2z',
    },
    {
      paint: 'epicJade',
      d: 'M-0.5,-15h0.5v0.5h-0.5zM0,-14.5h0.5v1h-0.5zM-1,-14h0.5v0.5h-0.5zM-1.5,-13.5h1v0.5h-1zM0.5,-13.5h1v0.5h-1zM-2,-13h0.5v1h-0.5zM0,-13h2v1h-2zM0,-12h1.5v0.5h-1.5zM-2.5,-11.5h0.5v0.5h-0.5zM0.5,-11.5h1.5v0.5h-1.5zM-0.5,-11h3v0.5h-3zM-3.5,-10.5h6.5v0.5h-6.5zM-3.5,-10h6v0.5h-6zM-3.5,-9.5h6.5v0.5h-6.5zM-4.5,-9h8v0.5h-8zM-5,-8.5h8.5v0.5h-8.5zM-5.5,-8h5.5v0.5h-5.5zM2,-8h1.5v0.5h-1.5zM-3.5,-7.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-0.5,-14.5h0.5v1h-0.5zM-0.5,-13.5h1v0.5h-1zM-1.5,-13h1.5v1h-1.5zM-2,-12h2v0.5h-2zM-2,-11.5h2.5v0.5h-2.5zM-3,-11h2.5v0.5h-2.5z',
    },
  ],
  pixels: 408,
};
export const sprites: readonly PixelSprite[] = [variant0];
